/**
 * Date Range Constants for Reports
 */

// Maximum number of days allowed for date range selection in reports
export const MAX_DATE_RANGE_DAYS = 92;

/**
 * Helper function to calculate max end date based on start date
 * @param {Date} startDate - The start date
 * @returns {Date} - The maximum allowed end date
 */
export const getMaxEndDate = (startDate) => {
  if (!startDate) return null;
  const maxDate = new Date(startDate);
  maxDate.setDate(maxDate.getDate() + MAX_DATE_RANGE_DAYS);
  return maxDate;
};

/**
 * Helper function to check if date range exceeds limit
 * @param {Date} startDate - The start date
 * @param {Date} endDate - The end date
 * @returns {boolean} - True if range exceeds max allowed days
 */
export const isDateRangeExceeded = (startDate, endDate) => {
  if (!startDate || !endDate) return false;
  const maxAllowed = new Date(startDate.getTime() + MAX_DATE_RANGE_DAYS * 24 * 60 * 60 * 1000);
  return endDate > maxAllowed;
};

/**
 * Validation message for date range
 */
export const DATE_RANGE_ERROR_MESSAGE = `End date cannot be more than ${MAX_DATE_RANGE_DAYS} days after start date`;
